// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__NIDsY","menu-body":"Popper_menu-body__2iyGc","scroll":"Popper_scroll__fuGkV","arrow-icon":"Popper_arrow-icon__IXLNK"};